export default "__VITE_PUBLIC_ASSET__02bf1c87__"